import ChooseUsersApp from "authentication/ChooseUsersApp";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const externalIdentityRoute: RouteObject = {
  path: "",
  children: [{
    path: "ChooseUser",
    loader: () => viewModel,
    Component: ChooseUsersApp,
  }]
};